var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessBusinessAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11329_190125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 7.39016V8.00349C14.6665 9.44111 14.201 10.8399 13.3402 11.9914C12.4794 13.1428 11.2695 13.9851 9.89089 14.3928C8.51227 14.8004 7.03882 14.7514 5.6903 14.2532C4.34177 13.755 3.19042 12.8342 2.40796 11.6282C1.6255 10.4222 1.25385 8.99553 1.34844 7.56103C1.44303 6.12653 1.99879 4.76104 2.93284 3.66821C3.86689 2.57537 5.12917 1.81375 6.53144 1.49692C7.93371 1.1801 9.40083 1.32505 10.714 1.91016M14.6673 2.67016L8.00066 9.34349L6.00065 7.34349",
    stroke: "#008813",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11329_190125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBusinessAccept);
export default __webpack_public_path__ + "static/media/successBusiness-accept.6b52f4773cb9e9d6fbb0ac03fbde3f3b.svg";
export { ForwardRef as ReactComponent };